<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import type { AlertVariants } from ".";
import { cn } from "@/lib/utils";
import { alertVariants } from ".";

const props = defineProps<{
  class?: HTMLAttributes["class"];
  variant?: AlertVariants["variant"];
  // shadcn marks every alert role="alert", which interrupts a screen reader
  // the moment it renders. That is right for an error that just happened and
  // wrong for a standing callout on a page, so only destructive defaults to it.
  role?: string;
}>();
</script>

<template>
  <div
    data-slot="alert"
    :class="cn(alertVariants({ variant }), props.class)"
    :role="role ?? (variant === 'destructive' ? 'alert' : undefined)"
  >
    <slot />
  </div>
</template>
